var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPolygonscan = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM19.195 12.5956L15.637 14.4513C15.4486 14.5492 15.215 14.5497 15.0265 14.4517L13.6884 13.7538V12.008L15.3315 12.8651L17.8265 11.5641V8.96169L15.3315 7.66071L12.8817 8.9385L12.8365 8.96169V15.5937C12.8365 15.7899 12.7199 15.973 12.5315 16.0713L8.97351 17.9266C8.78506 18.0245 8.55091 18.0245 8.36298 17.9266L4.80501 16.0709C4.61708 15.9726 4.5 15.7893 4.5 15.5932V11.8823C4.5 11.6857 4.61656 11.5028 4.80501 11.4046L8.36298 9.54886C8.45488 9.50064 8.56067 9.47513 8.66798 9.47513C8.7753 9.47513 8.88108 9.50064 8.97351 9.54886L10.3143 10.2479V11.9936L8.6685 11.1355L6.17346 12.4365V15.0389L8.6685 16.3399L11.1635 15.0389V8.40698C11.1635 8.21078 11.2801 8.02758 11.4685 7.92926L15.0265 6.07357C15.215 5.97571 15.4486 5.97524 15.637 6.07357L19.195 7.92926C19.383 8.02758 19.5 8.21078 19.5 8.40698V12.1179C19.5 12.3145 19.3835 12.4973 19.195 12.5956Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPolygonscan);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/polygonscan.07254b3eb2d5685cc4f1aca39addaa79.svg";